import { useEffect, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'

// Top bar publique (landing) — reprise de JLP-front/src/scripts/components/nav.js
export default function LandingNavbar() {
  const navRef = useRef(null)
  const linksRef = useRef(null)
  const toggleRef = useRef(null)
  const navigate = useNavigate()

  useEffect(() => {
    const onScroll = () => {
      const navEl = navRef.current
      if (!navEl) return
      if (window.pageYOffset > 100) navEl.classList.add('scrolled')
      else navEl.classList.remove('scrolled')
    }
    window.addEventListener('scroll', onScroll)
    onScroll()
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    const toggle = toggleRef.current
    const links = linksRef.current
    if (!toggle || !links) return
    const onClick = () => {
      links.classList.toggle('active')
      toggle.classList.toggle('active')
    }
    toggle.addEventListener('click', onClick)
    return () => toggle.removeEventListener('click', onClick)
  }, [])

  return (
    <div id="nav" ref={navRef}>
      <div className="nav-container">
        <div className="nav-content">
          {/* Logo (image uniquement, comme JLP-front) */}
          <a href="#hero" className="nav-logo">
            <img src="/brand/jean-louis-blanc.svg" alt="Jean Louis" className="nav-logo-img" />
          </a>

          {/* Liens */}
          <div className="nav-links" ref={linksRef}>
            <a href="#features" className="nav-link">Fonctionnalités</a>
            <a href="#pricing" className="nav-link">Tarifs</a>
            <a href="#faq" className="nav-link">Documentation</a>
            <Link to="/login" className="btn btn-ghost nav-signin">Se connecter</Link>
            <Link to="/register" className="btn btn-primary">Essayer gratuitement</Link>
          </div>

          {/* Toggle mobile */}
          <button className="nav-mobile-toggle" id="navToggle" ref={toggleRef} aria-label="Menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </div>
  )
}
